(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller("ServiceCategoriesController", ServiceCategoriesController);

  ServiceCategoriesController.$inject = ["$timeout", "$state"];

  function ServiceCategoriesController($timeout, $state) {
      function loadServiceCategories() {
            var serviceCategories = document.getElementById('service-categories');
            serviceCategories.addEventListener('toServices', function(e){
               $state.go("supplierPanel-v2.reserveServices")
           })
            serviceCategories.addEventListener('backToPrevVersion', function(e){
                $state.go("supplierPanel-v2.companyServiceCategoryList", { type: "services" }) 
            })

        }
        $timeout(loadServiceCategories, 100)

  }
})();


